import React from 'react';
import { useSelector } from 'react-redux';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { ColumnHeader } from '../../../OtherAssets/OtherAssets.meta';
import { IncomeTable } from '../../components/IncomeTable/IncomeTable';
import { formatCurrency } from '../../../../CommonUtils/formatNumber';
import { IncomeTableProps } from '../../Income.meta';
import { SocialSecurityEmpty } from './SocialSecurity.empty';
import { selectCurrentClient } from '../../../../CommonSelectors/CommonAreaSelector';
import { TableActions } from '../../components/TableActions/TableActions';
import { ClickableTableRow } from '../../../../CommonComponents/OPL/HtmlTable/HtmlTable';

const columnHeaders: ColumnHeader[] = [
  { text: 'Earner' },
  { text: 'Monthly Amount', align: 'right' },
];

export const SocialSecurity = ({
  clientId,
  data,
  incomeType,
  setIncomeToUpsert,
  setIncomeToDelete,
  workflowProps,
}: IncomeTableProps) => {
  const {
    Options: { IncomeTypeOptions },
  } = data;

  const { Dob: primaryDob } = useSelector(selectCurrentClient);

  const incomes = data.incomesDict[incomeType];
  const incomeTitle =
    IncomeTypeOptions.find(option => option.value === incomeType)?.label ||
    'Social Security Income';

  return (
    <IncomeTable
      title={incomeTitle}
      isEmpty={incomes.length === 0}
      emptyState={
        !primaryDob ? (
          <SocialSecurityEmpty clientId={clientId} workflowProps={workflowProps} />
        ) : null
      }
      columnHeaders={columnHeaders}
      workflowProps={workflowProps}
    >
      {incomes.map(income => (
        <ClickableTableRow
          variant="clickable"
          key={income.Id}
          onClick={() => {
            setIncomeToUpsert(income);
          }}
        >
          <td>
            <Text fontWeight={500} textAlign="left">
              {income.Name}
            </Text>
          </td>

          <td>
            <Text variant="tabular" fontWeight={500} textAlign="right">
              {income.Amount !== null ? formatCurrency(income.Amount) : '-'}
            </Text>
          </td>

          <TableActions
            incomeName={incomeTitle}
            onEdit={() => setIncomeToUpsert(income)}
            onDelete={() => setIncomeToDelete({ id: income.Id, name: income.Name })}
          />
        </ClickableTableRow>
      ))}
    </IncomeTable>
  );
};
